import React, { useCallback, useEffect, useRef } from "react";

import RecommmendatoionCarousel from "../components/carousel";
import Header from "../components/header";
import CarouselSkeleton from "../components/skeletonLoader";
import { recommendationConfig } from "../config";
import { PRODUCT_COUNT, Titles } from "../constants";
import { useSearchRecommendations } from "../context/SearchRecommendationContext";
import { RecommendationType } from "../enums";
import SendBrowserEvent from "../services/sendBrowserEvent.service";
import { Product } from "../types/model.types";
import { productItemToSlug } from "../utlis/helper.service";
import { RecommendationCarouselContainer } from "./RecommendationCarousel.styles";
import { useAnalyticsEvents } from "../hooks/useAnalyticsEvents";

export const RecommendationCarousel = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  let timeout: any;
  const { recommendations, productCards, loading, type, cartItem } =
    useSearchRecommendations();

  const { title, showLeftIcon, showSeeAll, showClose, sourceEvent } =
    recommendationConfig[type];
  const hasRecommendations = !!recommendations?.products?.length;
  const {trackPdpClick, trackAddToBasket, trackCarouselImpression, trackCarouselScroll, trackCarouselSeeAll} = useAnalyticsEvents()
  const impressionFiredRef = useRef(false);
  const isBasketPage = type === RecommendationType.BASKET;

  const onClickProduct = (item: Product, index: number) => {
    const productData = productItemToSlug(item);
    trackPdpClick(item,index,title, sourceEvent, recommendations.recommendationType, isBasketPage);
    SendBrowserEvent.onProductClick(productData);
  };

  const onClickAddToBasket = (item: Product, quantity: number, productIndex: number) => {
    trackAddToBasket(item,productIndex,title,quantity,cartItem, sourceEvent, recommendations.recommendationType, isBasketPage)
    SendBrowserEvent.onAddToBasketClick(item, quantity);
  };
  
  const onClickSeeAll = () => {
    onHeaderViewAll();
  };

  const onClickClose = () => {
    SendBrowserEvent.onCloseClick();
  };

  const sendHeightToParent = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const height = containerRef.current?.scrollHeight || 0;
      SendBrowserEvent.sendHeight(height);
    }, 50);
  };

  useEffect(() => {
    sendHeightToParent();

    const observer = new ResizeObserver(() => {
      sendHeightToParent();
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    if (!impressionFiredRef.current && hasRecommendations) {
      impressionFiredRef.current = true;
      const productIds = productCards.map((product: Product)=> product.id)
      trackCarouselImpression(title,sourceEvent, recommendations.recommendationType, productIds,isBasketPage);
    }
    return () => observer.disconnect();
  }, [hasRecommendations,recommendations]);

  const onCarouselScroll = useCallback(() => {
    trackCarouselScroll(title,sourceEvent, recommendations.recommendationType, isBasketPage);
  }, [title, recommendations]);

  const onHeaderViewAll = useCallback(() => {
    trackCarouselSeeAll(title,"carouselHeaderViewAllClick",sourceEvent, recommendations.recommendationType, isBasketPage);
    const timeOut = setTimeout(() => {
      SendBrowserEvent.onSeeAllClick();
      clearTimeout(timeOut);
    }, 800);
  }, [title, recommendations]);

  const onListViewAll = useCallback(() => {
    trackCarouselSeeAll(title,"carouselListViewAllClick",sourceEvent, recommendations.recommendationType, isBasketPage);
    const timeOut = setTimeout(() => {
      SendBrowserEvent.onSeeAllClick();
      clearTimeout(timeOut);
    }, 800);
  }, [title, recommendations]);

  const renderCarousel = recommendations ? (
    <RecommmendatoionCarousel
      recommendation={recommendations}
      productCards={productCards}
      onClickProduct={onClickProduct}
      addToBasketClick={onClickAddToBasket}
      cart={cartItem}
      type={type}
      onScroll={onCarouselScroll}

      onListViewAll={onListViewAll}
    />
  ) : null;

  const boughtTogether = (type === RecommendationType.BOUGHT_TOGETHER && hasRecommendations)
  const Wrapper = boughtTogether ? RecommendationCarouselContainer : React.Fragment;

  return (
    <div ref={containerRef} style={{ paddingBottom: hasRecommendations ? "24px" : '0px' }}>
      <Wrapper>
        {loading ? (
          <CarouselSkeleton />
        ) : (
          <>
            {hasRecommendations && (
              <>
                <Header
                  title={title}
                  showTitleIcon={showLeftIcon}
                  showSeeAll={recommendations?.products.length > PRODUCT_COUNT && showSeeAll}
                  showClose={showClose}
                  onClickSeeAll={onClickSeeAll}
                  onClickClose={onClickClose}
                  type={type}
                />
                {renderCarousel}
              </>
            )}
          </>
        )}
      </Wrapper>
    </div>
  );
};
